import { useState } from "react";

// The latest defined `value`, so a closing dialog keeps its content while it fades out.
const useLastDefined = <T>(value: T | undefined) => {
  const [last, setLast] = useState(value);
  if (value !== undefined && value !== last) {
    setLast(value);
  }
  return value ?? last;
};

export default useLastDefined;
